import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import StatusBadge from "@/components/StatusBadge";
import { fmtCurrency, fmtDate } from "@/lib/format";

export default function Schedules() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customer/schedules").then((r) => setItems(r.data)); }, []);

  const outstanding = items.filter((s) => s.status !== "paid").reduce((a, b) => a + (b.amount || 0), 0);

  return (
    <div className="space-y-8" data-testid="customer-schedules-page">
      <PageHeader eyebrow="Finance" title="Payment schedule" description="Milestone-linked dues and their status." />

      <div className="grid-surface p-5 border-l-4 border-l-brand-500">
        <div className="overline text-stone-500">Outstanding</div>
        <div className="font-display text-4xl font-black mt-1">{fmtCurrency(outstanding)}</div>
        <div className="text-xs text-stone-500 mt-1 font-mono">
          {items.filter((s) => s.status !== "paid").length} milestone(s) remaining
        </div>
      </div>

      <DataTable
        testId="my-schedules-table"
        columns={[
          { key: "milestone", label: "Milestone", render: (r) => <div className="font-bold">{r.milestone}</div> },
          { key: "unit", label: "Unit", render: (r) => <span className="font-mono">{r.unit?.unit_no || "—"}</span> },
          { key: "amount", label: "Amount", render: (r) => <span className="font-mono">{fmtCurrency(r.amount)}</span> },
          { key: "due_date", label: "Due", render: (r) => fmtDate(r.due_date) },
          { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
          { key: "description", label: "Note" },
        ]}
        rows={items}
        empty="No schedules yet."
      />
    </div>
  );
}
